import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';

import { BrokerService } from '@c4/core';

import { SharedProgrammingService } from '../../../common/services/shared-programming.service';
import { BaseRoutingComponent } from '../../../common/base-routing/base-routing.component';
import { ProgrammingUtilsService as Utils } from '../../../common/services/utils.service';
import { DeviceEvent } from '../../../common/interfaces/event.interface';
import { Command } from '../../../common/interfaces/command.interface';

import { RoomsProgrammingContext } from '../quickstart-rooms.service';

const EVENTS = [
  {
    id: 1,
    name: 'Room Off'
  },
  {
    id: 2,
    name: 'Audio Selection'
  },
  {
    id: 3,
    name: 'Video Selection'
  },
  {
    id: 2051,
    name: 'Pause Media'
  },
  {
    id: 2054,
    name: 'Play Media'
  }
]

@Component({
  templateUrl: './select-room.component.html',
  styleUrls: ['./select-room.component.less']
})
export class SelectRoomComponent extends BaseRoutingComponent {

  private _rooms: Observable<any>;
  private _eventId: number;
  private _command: string;

  constructor(
    protected store: Store<{
      roomsProgramming: RoomsProgrammingContext
    }>,
    private _shared: SharedProgrammingService,
    private _route: ActivatedRoute,
    private _broker: BrokerService,
    public router: Router
  ) {
    super();

    this._rooms = Observable.combineLatest(
      this.store.select(s => s.roomsProgramming.rooms).filter(r => !!r),
      this._route.params.map((params: { eventId: number }) => params.eventId),
      (rooms, eventId) => {
        return rooms.filter(room => {
          // console.log('select-room: filtering room', room);
          return room.events.some(evt => evt.eventId == eventId || evt.name == 'Commands') &&
            !!room.bindings &&
            room.bindings.length > 0;
        })
      }
    );

    // this._rooms.subscribe(r => console.log('select-room: rooms udpated', r));

    this._route.params.subscribe((params: { eventId?: number, command?: string }) => {
      this._command = params.command;
      this._eventId = params.eventId;
    });
  }

  select = (roomId: number) => {
    if (this._command !== undefined) this.selectAction(roomId);
    if (this._eventId !== undefined) this.selectEvent(roomId);
  }

  selectAction = (roomId: number) => {
    Observable.fromPromise(<Promise<Command[]>>this._broker.call({
      path: `/api/v1/locations/rooms/${roomId}/commands`
    }))
      .map(commands => commands.find(c => c.command == this._command))
      .subscribe(command => {
        if (!!command.params && command.params.length > 0) {
          this.router.navigate(['../' + command.deviceId, command.command], {
            relativeTo: this._route
          });
        } else {
          this._shared.saveAction(command);
        }
      })
  }


  selectEvent = (roomId: number) => {
    this._broker.call({
      path: `/api/v1/items/${roomId}/events`,
      queryString: {
        allEvents: true
      }
    }).then(events => {
      let event = this._buildEvent(this._eventId, events)
      // this._shared.setSelectedEvent(event);
      this.router.navigate(
        [['when-then', 'device', event.deviceId, 'event', event.eventId, 'add'].join('/')],
        {
          relativeTo: this.moduleRoot
        }
      )
    });
  }

  private _buildEvent = (eventId: number, events: DeviceEvent[]): DeviceEvent => {
    let event = events.find(e => e.eventId == eventId || e.name == 'Commands');
    event.eventId = event.eventId || eventId;
    return event;
  }

  private _isTrigger() {
    return window.location.href.indexOf('trigger') > -1;
  }

  private cancelClicked() {
    if (this._isTrigger()) {
      this.goHome();
    } else {
      this.goToEvent();
    }
  }
}



// WEBPACK FOOTER //
// ./~/@c4/programming/src/app/quickstarts/quickstart-rooms/select-room/select-room.component.ts